module.exports = __webpack_public_path__ + "img/pils.18d72cb2.png";